const AuthEnums = {
  keys: {},
  titles: {},
  facets: {
    OPTIONS: 'options',
    EMAIL_LINK: 'emailLink',
    EMAIL_LINK_SUCCESS: 'emailLinkSuccess',
    PHONE: 'phone',
    CODE_CONFIRM: 'codeConfirm',
    PASSPHRASE_LOGIN: 'passphraseLogin',
    PASSPHRASE_SETUP: 'passphraseSetup'
  },
  signInTypes: {
    GOOGLE: 'google.com',
    PASSWORD: 'password'
  },
  routes: {
    ROOT: '/',
    LOGIN: '/login',
    CHECKIN: '/checkin',
    REGISTER: '/register',
    PAY_STATUS: '/payment-status',
    DASHBOARD: '/dashboard',
    PERSONAL_DETAILS: '/personal-details',
    MEDICAL_HISTORY: '/medical-history',
    MY_BOOKINGS: '/my-bookings',
    DIAGNOSIS_HISTORY: '/diagnosis-history',
    VIRTUAL_CONSULT: '/virtual-consult'
  },
  localStorage: {
    EMAIL_FOR_SIGN_IN: 'emailForSignIn',
    PASSPHRASE_TEMP_USER: 'passphraseTemporaryUser'
  },
  passphraseMessages: {
    OTP_ALTERNATIVE: 'Not receiving your OTP or having trouble logging in?',
    USE_PASSPHRASE: 'Use your backup passphrase instead',
    SETUP_REQUIRED: 'For security, please set up a backup passphrase',
    SETUP_PROMPT: 'This will help you access your account if SMS/email login fails'
  }
}

export default AuthEnums
